module.exports = __webpack_public_path__ + "img/investMini.86262c6e.jpg";